// @flow

import { useContext } from 'react';
import { type Validation } from './types';
import { ValidationContext } from './context';

export function useValidation(): Validation {
  const validation = useContext(ValidationContext);
  if (!validation) {
    throw new Error('ValidationContext was not provided');
  }
  return validation;
}
